import React from "react";
import {ColumnVisibility, Task} from "../../types/public-types";
import styles from "./task-list-header.module.css";

interface TaskListHeaderProps<T extends Task> {
  headerHeight: number;
  rowWidth: string;
  fontFamily: string;
  fontSize: string;
  columnList: ColumnVisibility<T>[];
}

export type TaskListHeaderPropsType<T extends Task> = (prop : TaskListHeaderProps<T>) => React.ReactElement<any, any>;

export const TaskListHeaderDefault = <T extends Task,>({ headerHeight, fontFamily, fontSize, columnList}: TaskListHeaderProps<T>): React.ReactElement<any, any> => {

    // console.log(styles)
  return (
    <div
      className={styles.ganttTable}
      style={{
        fontFamily: fontFamily,
        fontSize: fontSize,
      }}
    >
      <div
        className={styles.ganttTableHeader}
        style={{
          height: headerHeight - 2,
        }}
      >
        {columnList.map((columnVisibility,index) => {
          if(columnVisibility.isVisible === true) {
            return (
              <div
                key={index}
                className={styles.ganttTableHeaderItem}
                style={{
                  minWidth: columnVisibility.width,
                }}
              >
                &nbsp;{columnVisibility.columnName}
              </div>
            )
          }
          else {
            return(<div key={index}></div>);
          }
        })}

        {/* <div
          className={styles.ganttTable_HeaderItem}
          style={{
            minWidth: rowWidth,
          }}
        >
          &nbsp;Name
        </div>
        <div
          className={styles.ganttTable_HeaderSeparator}
          style={{
            height: headerHeight * 0.5,
            marginTop: headerHeight * 0.2,
          }}
        />
        <div
          className={styles.ganttTable_HeaderItem}
          style={{
            minWidth: rowWidth,
          }}
        >
          &nbsp;From
        </div>
        <div
          className={styles.ganttTable_HeaderSeparator}
          style={{
            height: headerHeight * 0.5,
            marginTop: headerHeight * 0.25,
          }}
        />
        <div
          className={styles.ganttTable_HeaderItem}
          style={{
            minWidth: rowWidth,
          }}
        >
          &nbsp;To
        </div> */}
      </div>
    </div>
  );
};
